import React, { useState } from 'react';

const Hero_1 = () => {
  const steps = [
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__how-it-works-section__search-icon.svg",
      title: "Select a Service",
      description:
        "Visit Adopt a Pet's website or app and browse through the various services offered such as cat and dog grooming, cat and dog boarding, dog walking, veterinary care, dog training, dog insurance, pet re-home or adoption. Choose the service that best fits the needs of your pet.",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__how-it-works-section__chat-icon.svg",
      title: "Book an appointment",
      description:
        "Once you've selected a service, choose a convenient date and time for the appointment. Fill in any required information about your pet that can help in providing the best care possible. Confirm the booking by making an online payment or selecting to pay in person if available.",
    },
    {
      icon: "//dm6g3jbka53hp.cloudfront.net/static-images/homepage__how-it-works-section__cart-icon.svg",
      title: "Enjoy & Relax",
      description:
        "After booking the appointment, you just need to prepare your pet for the service. On the appointed day, wait for the mobile service to arrive at your home. Then, simply relax knowing your pet is in good hands and enjoy the peace of mind that comes with professional care.",
    },
  ];
  
  const reviews = [
    {
      name: "Mrs. Vedita",
      date: "May 10, 2023",
      rating: 5,
      review: "We had such a fantastic experience with the grooming professionals! They did an impeccable job grooming our Maltese, and their friendly demeanor made our dog incredibly calm throughout the session. The attention to detail was outstanding, and the grooming work was nearly perfect. We are truly impressed and grateful for their excellent service!",
      service: "Pet Grooming",
      beforeImage: "//dm6g3jbka53hp.cloudfront.net/static-images/zoro-tpn-before-grooming-05012020.jpg",
      afterImage: "//dm6g3jbka53hp.cloudfront.net/static-images/zoro-tpn-after-grooming-05012020.jpg",
      petDetails: "Casper: Before and After",
    },
    {
      name: "Mr. Raj",
      date: "June 15, 2023",
      rating: 5,
      review: "Undoubtedly, Dr. Gaurav is the finest vet I've ever encountered! I've turned to Dr. Gaurav for help, advice, and diagnoses for various cases over the past decade, and he has consistently proven to be the most helpful and knowledgeable vet I know.",
      service: "Vet Service",
      duringImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_vet-review-image-2.png",
      treatmentImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_vet-review-image-3.png",
      petDetails: "Tyson: During Treatment",
    },
    {
      name: "Ms. Nidhi",
      date: "September 01, 2023",
      rating: 5,
      review: "Absolutely thrilled with the exceptional service provided by ThePetNest! Every aspect has exceeded our expectations. Tony adores Rakesh and eagerly anticipates their walks, often waiting by the door in excitement.",
      service: "Dog Walking",
      firstImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_walking-review-image-1.png",
      secondImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_walking-review-image-2.png",
      petDetails: "Tony: During Walks",

    },
    {
    name: "Mr. Vikas",
    date: "October 30, 2023",
    rating: 5,
    review: "Our first experience on Adopt a pet was absolutely delightful! We're thrilled to have found this service. Our dog not only looked happy but was also incredibly energetic after the stay. The daily reviews provided were exceptionally detailed, accompanied by some lovely pictures and videos that melted our hearts. 😍 Thank you for the excellent care and service!",
    service: "Pet Boarding",
    firstImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_boarding-review-image-1.png",
    secondImage: "//dm6g3jbka53hp.cloudfront.net/static-images/home-page_user-reviews-section_boarding-review-image-2.png",
    petDetails: "Zoro's Boarding Stay",
  },
  {
    name: "Akshay Mawle",
    date: "October 24, 2024",
    rating: 5,
    review: "The grooming was done so well..both the groomers were extremely professional and polite..and took care of my dog well..all the services included were done very well..both mohan and nagesh are very talented well spoken and professional..all the cleaning also was done by them while doing any service and even after everything was done..",

  },
  {
    name: "Mitali Pradhan",
    date: "October 22, 2024",
    rating: 5,
    review: "On first day i also walked with him to show around area. he was punctual. he is very knowledgeable, kin to know the area and my dogs behaviour and really knows how to handle pet on busy road. gave me tips on how to handle my dog and how to understand our pet in better way. my dog also loved him immediately. i would totally recommend him.",

  },
  {
    name: "Daryl Peris",
    date: "October 05, 2024",
    rating: 5,
    review: "Farhan is very kind with cats and knows how to keep them calm. he will first spend time in calming them and making them feel safe. only after the cat is safe he will start slowly grooming and does a very good job always! my prior experience with other groomers was not so good where they would just start grooming process without any concern for the cat's comfort.",

  },
  {
    name: "Deepali Singh",
    date: "August 18, 2024",
    rating: 5,
    review: "Well knowledged, experienced and he knows their work how to give best to best service to their customers. My dog loves their services, and every single problem my dog faced was treated nicely. He always recommended home remedies, which were very effective. I always recommend getting services for your dog from Waseem sir 👍",

  },
  {
    name: "Oblesh Thakur",
    date: "August 14, 2024",
    rating: 5,
    review: "Had an amazing session for my beloved cat. Mohan and Rakesh were superb at the job. They handled him with love and care, were very careful and calm while dealing with the cat. The trim was done perfectly as asked before starting the session and they made sure I double-checked everything to my satisfaction. Would definitely book them again. Thanks!",

  },
  {
    name: "Moumita Chakraborty",
    date: "August 03, 2024",
    rating: 5,
    review: "The groomer Mr. Gautam was very cordial, professional, and knows very well how to handle a pampered spoiled Shih Tzu. My daughter was very relaxed throughout the procedure. This is my first time with a home service experience, and I will definitely avail the services at least once a month. The groomer understands my taste and styled my princess accordingly. Very much recommended!",


  },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    if (currentSlide < reviews.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };
  return (
    <div className="mt-14">
      <div className="bg-slate-100 py-8">
        <div className="text-center mb-10">
          <p className="text-3xl font-bold pt-10">How to book a service with Adopt a Pet</p>
          <p className="text-gray-600">Charges may vary based on Pet and City.</p>
        </div>
        <div className="steps-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-10 mx-4">
          {steps.map((step, index) => (
            <div key={index} className="text-center p-4 border border-gray-200 rounded-lg shadow-md">
              <img src={step.icon} alt={step.title} className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="reviews-container mx-auto max-w-full p-4 mt-14">
  <h2 className="text-3xl font-bold text-center mb-6">Reviews from Our Happy Pet Parents</h2>
  <div className="overflow-x-auto">
    <div className="flex gap-6 justify-start">
      {reviews.map((review, index) => (
        <div key={index} className="review-card border border-gray-200 rounded-lg shadow-md p-4 w-full h-auto flex-col">
          <div className="review-header w-[300px] h-auto md:w-[500px] ">
            <h3 className="text-xl font-semibold">{review.name}</h3>
            <p className="text-sm text-gray-500">{review.date}</p>
            <div className="rating mt-1 text-yellow-500">
              {"⭐".repeat(review.rating)}
            </div>
          </div>
          <div className="review-body mt-4">
            <p className="text-gray-700">{review.review}</p>
          </div>
          {/* <div className="review-images flex flex-wrap mt-4 gap-2">
            {review.beforeImage && (
              <img
                src={review.beforeImage}
                alt="Before"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
            {review.afterImage && (
              <img
                src={review.afterImage}
                alt="After"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
            {review.duringImage && (
              <img
                src={review.duringImage}
                alt="During"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
            {review.treatmentImage && (
              <img
                src={review.treatmentImage}
                alt="Treatment"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
            {review.firstImage && (
              <img
                src={review.firstImage}
                alt="First"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
            {review.secondImage && (
              <img
                src={review.secondImage}
                alt="Second"
                className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 rounded-lg"
              />
            )}
          </div> */}
        </div>
      ))}
    </div>
  </div>
</div>


    </div>
  );
};

export default Hero_1;
